// extracted by mini-css-extract-plugin
export default {"navigator":"NavigationArrows_navigator__3IdrK","leftArrow":"NavigationArrows_leftArrow__2ScnV","disable":"NavigationArrows_disable__5iqA6"};